export enum ROLES {
    Assistant = 1,
    Professional = 2,
    Administrator = 3
}
